import { ThemeOptions } from "@mui/material";
import { createContext } from "react";

export const themeVariablesLight: ThemeOptions = {
  palette: {
    mode: "light",
    primary: {
      main: "#8B4513",
    },
    secondary: {
      main: "#2E8B57",
    },
    background: {
      paper: "#F5DEB3",
    },
  },
};

export const themeVariablesDark: ThemeOptions = {
  palette: {
    mode: "dark",
    primary: {
      main: "#ffd700",
    },
    secondary: {
      main: "#a9a9a9",
    },
    background: {
      paper: "#1c1c1c",
    },
  },
};

// export const theme = createTheme(themeVariablesDark);

const systemVariables = {
  systemName: "Kiwi ICP",
  toggleColorMode: () => {},
};

export const SystemContext = createContext(systemVariables);
